module.exports = __webpack_public_path__ + "static/media/FormatUploadBudget.0293844c.JPG";